import {observer, React} from '@api'
import {useStores} from '@modules'
import {PrimaryIconButton} from 'centric-ui-components'

export const PresentationModeButton = observer(function PresentationModeButton() {
  const {catalog: {isGroupedView, presentation: {settings: {show}, togglePresentationMode}}} = useStores()

  if (!DEBUG || !isGroupedView) return null

  return (<PrimaryIconButton
    icon='presentation'
    tooltip='Presentation Mode'
    active={show === true}
    onClick={togglePresentationMode}/>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/PresentationMode/TogglePresentationModeButton.tsx